import { Component, OnInit, HostListener, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';

// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';


import { QueryService } from '../query.service';
import { CartService } from '../../store/cart/cart.service';
import { Product } from '../../_models/product';
import { ApplicationNotificationService } from '../application-notification.service';

@Component({
  moduleId: module.id,
  selector: 'app-search-box',
  templateUrl: 'search-box.component.html'
})

export class SearchBoxComponent implements OnInit {
  @Input() displayedInHQ: boolean = false;
  products: Observable<{} | Product[]>;
  public searching: boolean = false;
  public searchString: string = '';
  private searchTerms = new Subject<string>();

  constructor(private queryService: QueryService, private elementRef: ElementRef, public cartService: CartService,
              public router: Router, public notificationService: ApplicationNotificationService ) {}

  @HostListener('document:click', ['$event'])
  clickout(event:any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.searching = false;
    }
  }

  clickedOnProduct(product:Product) {
    this.router.navigateByUrl('/hq/view-cards/' + product.id).then(_ => {
      this.notificationService.addGrowl('Successfully navigated to ' + product.name);
      this.searching = false;
    });
  }

  search(term: string): void {
    this.searchString = encodeURIComponent(term);
    this.searchTerms.next(this.searchString);
  }

  ngOnInit(): void {
    this.products = this.searchTerms
      .debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => term   // switch to new observable each time the term changes
        // return the http search observable
        ? this.queryService.searchProducts(term, this.displayedInHQ)
        // or the observable of empty products if there was no search term
        : Observable.of<Product[]>([])
        )
      .catch(error => {
        // TODO: add real error handling
        console.log(error);
        return Observable.of<Product[]>([]);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/search-products/search-box.component.ts